import clsx from "clsx";

function Skeleton({ className, ...rest }) {
  return <div aria-hidden="true" {...rest} className={clsx("animate-pulse rounded bg-surface-alt motion-reduce:animate-none", className)} />;
}

export default Skeleton;
